import { useEffect, useRef, type RefObject } from "react";

/**
 * Grows a textarea with its content up to maxHeightPx, then scrolls.
 * Returns a ref to attach to the textarea element.
 */
export function useAutoResizeTextarea(
  value: string,
  maxHeightPx = 320
): RefObject<HTMLTextAreaElement | null> {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    const next = Math.min(el.scrollHeight, maxHeightPx);
    el.style.height = `${next}px`;
    el.style.overflowY = el.scrollHeight > maxHeightPx ? "auto" : "hidden";
  }, [value, maxHeightPx]);

  return ref;
}
